import type { TrackerOperationalStatus, TrackerStoreListItem } from './tracker-types.js';

export interface TrackerStoreProgressSummary {
    totalStores: number;
    started: number;
    notStarted: number;
    operatorComplete: number;
    operatorAndComplianceComplete: number;
}

export function computeTrackerStoreProgressSummary(
    stores: TrackerStoreListItem[],
): TrackerStoreProgressSummary {
    const totalStores = stores.length;
    const started = stores.filter((store) => store.operationalStatus !== 'NOT_STARTED').length;
    const operatorComplete = stores.filter((store) => store.operationalStatus === 'COMPLETE').length;
    const operatorAndComplianceComplete = stores.filter(
        (store) => store.operationalStatus === 'COMPLETE' && store.complianceStatus === 'COMPLETE',
    ).length;

    return {
        totalStores,
        started,
        notStarted: totalStores - started,
        operatorComplete,
        operatorAndComplianceComplete,
    };
}

export function formatTrackerOperationalStatus(status: TrackerOperationalStatus): string {
    switch (status) {
        case 'NOT_STARTED':
            return 'Not Started';
        case 'IN_PROGRESS':
            return 'In Progress';
        case 'COMPLETE':
            return 'Operator Complete';
        default: {
            const exhaustive: never = status;
            return exhaustive;
        }
    }
}

export function formatTrackerComplianceStatus(
    status: TrackerStoreListItem['complianceStatus'],
): string {
    switch (status) {
        case 'NOT_STARTED':
            return 'Not Started';
        case 'IN_REVIEW':
            return 'In Review';
        case 'COMPLETE':
            return 'Compliance Complete';
        default: {
            const exhaustive: never = status;
            return exhaustive;
        }
    }
}
